module.exports = __webpack_public_path__ + "static/media/git.c87f031f.png";